import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Button, Select, TabPane } from 'element-ui';
import axios from 'axios'
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Button);
Vue.use(Select);
Vue.use(TabPane);
new Vue({
  el: '#app',
  render: h => h(App),
}).$mount('#app')
